import {ApiException, ValidationError} from '@dms/api/shared';

export type WithValidationErrors<T> = T | ValidationError[];

// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
export function isApiException(x: any): x is ApiException {
  return x.validationErrors !== undefined;
}

export type {ApiException};
